import React, { useState } from 'react';
import { Text } from '@mantine/core';

const theme = {
  background: { secondary: '#161B22', tertiary: '#21262D', elevated: '#2D333B' },
  text: { secondary: '#9CA3AF', primary: '#F9FAFB' },
  border: { primary: '#374151', secondary: '#4B5563' }
};

const ClickableHelpText: React.FC<{ text: string; detailedInfo: string | undefined }> = ({ text, detailedInfo = undefined }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Скрытие тултипа при клике вне компонента
  React.useEffect(() => {
    if (!showTooltip) return;
    const handleClick = (e: MouseEvent) => {
      // @ts-ignore
      if (!e.target.closest('.clickable-help-text-root')) setShowTooltip(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showTooltip]);

  return (
    <div className="clickable-helpmedian_mint_traid_duration_seconds_max-text-root" style={{ position: 'relative', display: 'inline-block' }}>
      <Text 
        size="xs" 
        style={{ 
          backgroundColor: theme.background.secondary, 
          padding: '2px 6px', 
          borderRadius: '4px',
          border: `1px solid ${theme.border.primary}`,
          cursor: 'pointer',
          transition: 'all 0.2s',
          color: theme.text.secondary, // Явно задаем цвет текста
        }}
        onClick={() => setShowTooltip(!showTooltip)}
      >
        {text}
      </Text>
      {showTooltip && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: theme.background.elevated,
          border: `1px solid ${theme.border.primary}`,
          borderRadius: '6px',
          padding: '12px 16px',
          fontSize: '12px',
          color: theme.text.primary,
          minWidth: '200px',
          maxWidth: '300px',
          width: 'max-content',
          textAlign: 'left',
          lineHeight: '1.4',
          zIndex: 1000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          marginBottom: '4px'
        }}>
          {detailedInfo}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: `6px solid ${theme.background.elevated}`
          }} />
        </div>
      )}
    </div>
  );
};

export default ClickableHelpText;
